<div class="card-header d-flex justify-content-between align-items-center">
    <div class="d-flex justify-content-between">
        <h5 class="mb-0">{{ notificationType() == notificationTypeEnum.Notification ? "Notifications" : "Messages" }}</h5>
        @if (isSideNav()) {
            <button (click)="navService.closeAllNavs()" type="button"
                class="btn d-flex align-items-center px-1 py-0 dismiss-btn">
                <fa-icon [icon]="faX"></fa-icon>
            </button>
        }
    </div>
    <div class="d-flex">
        <div class="btn-group">
            <button class="btn btn-sm" [class.btn-primary]="!(showUnreadOnly())"
                [class.btn-outline-primary]="showUnreadOnly()" (click)="setUnreadFilter(false)">
                All
            </button>
            <button class="btn btn-sm" [class.btn-primary]="showUnreadOnly()"
                [class.btn-outline-primary]="!(showUnreadOnly())" (click)="setUnreadFilter(true)">
                Unread ({{ unreadCount() }})
            </button>
        </div>
        <div class="ml-2 d-flex align-items-center">
            @if(userModules().length > 1) {
                <ng-container *ngTemplateOutlet='baDropDown'></ng-container>
            }
        </div>
    </div>
</div>

<div class="card-body">
    <!-- Mark all as Read / Trash / Settings btns -->
    <div class="mb-3 text-right d-flex justify-content-end align-items-center gap-2">
        @if (filteredNotifications().length > 0) {
            <button class="btn btn-light btn-sm" (click)="markAllAsRead()">
                <fa-icon [icon]="faCheckDouble" class="me-2 text-primary"></fa-icon>
                Mark all as read
            </button>
            <button class="btn btn-light btn-sm" (click)="deleteAllNotifications()"
                [ngbTooltip]="'Delete all ' + (notificationType() == notificationTypeEnum.Notification ? 'notifications' : 'messages')" placement="left">
                <fa-icon [icon]="faTrash" class="text-primary"></fa-icon>
            </button>
        }
        <button class="btn btn-light btn-sm" (click)="navToSettings()" [ngbTooltip]="'Manage notification settings'"
            placement="left">
            <fa-icon [icon]="faGear" class="me-2 text-primary"></fa-icon>
        </button>
    </div>

    <div #notificationsList class="notifications-list" (scroll)="onScroll($event)">
        @for (notification of filteredNotifications(); track notification.userNotificationId) {
            <!-- Notification card -->
            <div class="notification-item d-flex align-items-start" [class.read]="notification.markedAsRead" 
                [style.cursor]="notification.link ? 'pointer' : 'default'">
                <!-- Business Area Icon -->
                <div class="ba-icon-circle d-flex align-items-center justify-content-center mr-2"
                        [style.color]="baService.getIconStyleByBusinessArea(notification.businessArea).color"
                        [style.background-image]="'linear-gradient(to bottom right, white 0%, ' + baService.getIconStyleByBusinessArea(notification.businessArea).background + ' 60%)'">
                            <fa-icon class="ba-icon" [icon]="baService.getIconByBusinessArea(notification.businessArea)"></fa-icon>
                </div>
                
                <div class="d-flex flex-column w-100">
                    <div class="d-flex align-items-start justify-content-between">
                        <!-- Message + Time sent -->
                        <div class="notification-content" (click)="onClickNotification(notification);">
                            <p class="mb-1">{{ notification.title }}</p>

                            <small 
                                class="text-muted border-bottom-0" 
                                [ngbTooltip]="notification.notifiedDate | utcToLocal | date:'MMM d, y, h:mm a'"
                                container="body" placement="top">
                                {{ notification.notifiedDate | utcToLocal | timeAgo }}
                            </small>

                            <small class="text-dark d-flex flex-row align-items-center" data-dd-privacy="mask">
                                @if (notification.isEncrypted) {
                                    <fa-icon
                                        class="me-1 text-muted"
                                        [icon]="faLock"
                                        ngbTooltip="This message is protected. Open the record to read it."
                                        container="body"
                                        placement="top" />
                                }
                                {{ notification.message }}
                            </small>
                        </div>
                        
                        <!-- Dropdown + Mark as read btn -->                 
                        <ng-container *ngTemplateOutlet='dropDown; context: { notification: notification }'></ng-container>
                    </div>
                </div>
            </div>
        } @empty {
            <div class="text-center text-muted py-3">
                No {{ notificationType() == notificationTypeEnum.Notification ? "notifications" : "messages" }} to display
            </div>
        }
    </div>

    @if (hasMoreNotifications() && !navService.isMobile()) {
        <div class="text-center mt-3">
            <button class="btn btn-outline-primary btn-sm" (click)="showMore()">
                Show previous {{ notificationType() == notificationTypeEnum.Notification ? "notifications" : "messages" }}
            </button>
        </div>
    }
</div>

<!-- Business Area filter dropdown -->
<ng-template #baDropDown>
    <div ngbDropdown placement="bottom-end">
        <button 
            class="btn btn-light remove-dropdown-arrow" 
            ngbDropdownToggle>
            <fa-icon class="text-primary" [icon]="faFilter" />
        </button>
        <div class="filter-dropdown" ngbDropdownMenu>
            @for (businessArea of userModules(); track businessArea) {
                <button class="btn btn-sm rounded-0 col-4" (click)="toggleBusinessArea(businessArea)"
                    [class.text-secondary]="!selectedBusinessAreas().includes(businessArea)"
                    [ngbTooltip]="toDescription(businessArea)"
                    [style.color]="selectedBusinessAreas().includes(businessArea) ? baService.getIconStyleByBusinessArea(businessArea).background : null">
                    <fa-icon [icon]="baService.getIconByBusinessArea(businessArea)"/>
                </button>
            }
            <div class="col-12 text-center mt-1">
                @if(selectedBusinessAreas()?.length > 0) {
                    <button 
                        class="btn btn-outline-primary" 
                        (click)="selectedBusinessAreas.set([])">
                        Clear
                    </button>
                }
            </div>
        </div>
    </div>
</ng-template>


<!-- Dropdown + Marked as read btn -->
<ng-template #dropDown let-notification="notification">
    <div class="d-flex align-items-center" (click)="$event.stopPropagation()">
    @if (!notification.markedAsRead) {
        <span class="btn-primary unread-dot mr-1" (click)="markAsRead(notification)"></span>
    }
        <div class="dropdown" ngbDropdown placement="bottom-right">
            <button class="btn btn-link p-0 menu-toggle remove-dropdown-arrow" ngbDropdownToggle>
                <i class="menu-triangle"></i>
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
                @if (!notification.markedAsRead) {
                    <button ngbDropdownItem (click)="markAsRead(notification)">
                        Mark as read
                    </button>
                    <button ngbDropdownItem 
                        (click)="unsubscribe(notification)"
                        [class.text-secondary]="!notification.subscription"
                    >
                        Unsubscribe                     
                    </button>
                }
                <button ngbDropdownItem (click)="navigateToLink($safeNavigationMigration(notification?.link))">
                    View Details
                </button>
                <button ngbDropdownItem (click)="deleteNotification(notification)">
                    Delete
                </button>
            </div>
        </div>
    </div>
</ng-template>